
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-wine-glass-fill text-red-500 text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
                Licores Don Juan
              </h3>
            </div>
            <p className="text-gray-400 mb-4">
              Tu licorera de confianza en Bogotá. Servicio a domicilio con entrega en 30-45 minutos.
            </p>
            <div className="flex space-x-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-facebook-fill text-xl hover:text-red-500 transition-colors cursor-pointer"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-instagram-fill text-xl hover:text-red-500 transition-colors cursor-pointer"></i>
              </div>
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-whatsapp-fill text-xl hover:text-red-500 transition-colors cursor-pointer"></i>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Productos</h4>
            <ul className="space-y-2 text-gray-400">
              <li className="hover:text-white transition-colors cursor-pointer">Licores Nacionales</li>
              <li className="hover:text-white transition-colors cursor-pointer">Licores Importados</li>
              <li className="hover:text-white transition-colors cursor-pointer">Vinos y Champañas</li>
              <li className="hover:text-white transition-colors cursor-pointer">Cervezas</li>
              <li className="hover:text-white transition-colors cursor-pointer">Whisky Premium</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Servicios</h4>
            <ul className="space-y-2 text-gray-400">
              <li className="hover:text-white transition-colors cursor-pointer">Entrega 30-45 min</li>
              <li className="hover:text-white transition-colors cursor-pointer">Toda Bogotá</li>
              <li className="hover:text-white transition-colors cursor-pointer">Pago Contraentrega</li>
              <li className="hover:text-white transition-colors cursor-pointer">Atención 24/7</li>
              <li className="hover:text-white transition-colors cursor-pointer">Asesoría Personalizada</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contacto</h4>
            <div className="space-y-3 text-gray-400">
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-fill"></i>
                </div>
                <span>310 255 1833</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-fill"></i>
                </div>
                <span>333 248 3675</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-fill"></i>
                </div>
                <span>321 258 5307</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-fill"></i>
                </div>
                <span>WhatsApp disponible</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-fill"></i>
                </div>
                <span>Bogotá, Colombia</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 Licores Don Juan. Todos los derechos reservados.</p>
          <p className="mt-2">
            <a href="https://readdy.ai/?origin=logo" className="hover:text-red-500 transition-colors cursor-pointer">
              Powered by Readdy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
